"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = _interopRequireDefault(require("./Table.style"));
var _excluded = ["children", "borderless", "striped", "align", "hoverable"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Table = function Table(_ref) {
  var children = _ref.children,
    borderless = _ref.borderless,
    striped = _ref.striped,
    align = _ref.align,
    hoverable = _ref.hoverable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Table["default"], _extends({
    borderless: borderless,
    striped: striped,
    align: align,
    hoverable: hoverable
  }, otherProps), children);
};
Table.defaultProps = {
  borderless: false,
  striped: true,
  align: 'left',
  hoverable: false
};
Table.propTypes = {
  /** The alignment of the table text */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),
  /** Flag to indicate if table should have borders */
  borderless: _propTypes["default"].bool,
  /** The content of the table, normally `TableHeader` and `TableBody`. */
  children: _propTypes["default"].node.isRequired,
  /** Flag to indicate if table rows should have a differnt hover color */
  hoverable: _propTypes["default"].bool,
  /** Flag to indicate if table rows should alternate colors */
  striped: _propTypes["default"].bool
};
var _default = exports["default"] = Table;